import { required } from "vuelidate/lib/validators";

export default class ProdutosValorData {
  id_faixa_revenda = "";

  id_kit = null;

  valor = 0;

  constructor({ id_faixa_revenda = "", id_kit = null, valor = 0 }) {
    this.id_faixa_revenda = id_faixa_revenda;
    this.id_kit = id_kit;
    this.valor = valor;
  }
}

export const ProdutosValorDataRequired = {
  id_kit: {
    required
  },
  id_faixa_revenda: {
    required
  },
  valor: {
    required
  }
};
